angular.module("khUtils").factory("FmsConstantsFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/fms/fmsconstants/', {}, {
        query: {
            isArray: false,
            cache: true
        }
    });
}]);